export const PATIENT_NAME_USE_TYPES = {
    NAME_USE_A: 'Artist/Stage',
    NAME_USE_ABC: 'Alphabetic',
    NAME_USE_ASGN: 'assigned',
    NAME_USE_C: 'License',
    NAME_USE_I: 'Indigenous/Tribal',
    NAME_USE_IDE: 'Ideographic',
    NAME_USE_L: 'Legal',
    NAME_USE_OR: 'official registry',
    NAME_USE_P: 'pseudonym',
    NAME_USE_PHON: 'phonetic',
    NAME_USE_R: 'Religious',
    NAME_USE_SNDX: 'Soundex',
    NAME_USE_SRCH: 'search',
    NAME_USE_SYL: 'Syllabic',
};
